import { useState } from 'react';
import { apiPost } from '@/lib/api';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Layers, ClipboardCheck, FileText, Puzzle, Loader2 } from 'lucide-react';

export const MATERIAL_KINDS = [
  ['flashcards', 'Flashcards', Layers], ['quiz', 'Quiz', ClipboardCheck],
  ['worksheet', 'Worksheets', FileText], ['puzzle', 'Matching puzzles', Puzzle],
];
export function SchoolMaterialBuildDialog({ version, onClose, onBuilt }) {
  const [selected, setSelected] = useState({});
  const [busy, setBusy] = useState(false);
  const build = async () => {
    setBusy(true);
    try {
      await apiPost(`/admin/school-mapping/versions/${version.version_id}/build`, { kinds: Object.keys(selected).filter(k => selected[k]) });
      toast.success('Selected materials are being created. Ready materials are reused.'); onBuilt?.(); onClose();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return <Dialog open={!!version} onOpenChange={o => { if (!o) onClose(); }}>
    <DialogContent data-testid="school-material-build-dialog" className="max-w-md max-h-[90dvh] overflow-y-auto">
      <DialogTitle>Syllabus approved · choose materials</DialogTitle>
      <DialogDescription data-testid="school-build-scope">{version.subject} · {version.label || version.version_id}</DialogDescription>
      <div className="divide-y">{MATERIAL_KINDS.map(([key, name, Icon]) => <label key={key} className="flex gap-3 py-4 items-center cursor-pointer"><input data-testid={`school-build-${key}`} type="checkbox" checked={!!selected[key]} onChange={e => setSelected(p => ({ ...p, [key]: e.target.checked }))} /><Icon className="h-5 w-5 text-sky-600" /><span className="text-sm flex-1">{name}</span><span data-testid={`school-build-status-${key}`} className="text-xs text-muted-foreground">{version.materials?.[key]?.status?.replace('_', ' ') || 'Not requested'}</span></label>)}</div>
      <div className="flex gap-2 justify-end"><Button data-testid="school-build-later" variant="ghost" onClick={onClose}>Later</Button><Button data-testid="school-build-submit" disabled={busy || !Object.values(selected).some(Boolean)} onClick={build}>{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Create selected</Button></div>
    </DialogContent>
  </Dialog>;
}